<div class="perm-page">
    <div class="perm-header-bar">
        <div class="perm-header-icon">
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none"><path d="M12 3l7 3v6c0 4.5-3 8-7 9-4-1-7-4.5-7-9V6l7-3z" stroke="#00a0e1" stroke-width="1.8" stroke-linejoin="round"/></svg>
        </div>
        <div class="perm-header-text">
            <p class="perm-title">Gestión de Permisos por Roles</p>
            <p class="perm-subtitle">Administra los permisos de cada rol sobre los módulos del sistema — incluidos los submenús de cada módulo.</p>
        </div>
        <button type="button" class="perm-save-btn" (click)="guardarCambios()" [disabled]="!hayCambiosPendientes">
            <svg viewBox="0 0 24 24" width="16" height="16" fill="none"><path d="M3 12a9 9 0 1 0 3-6.7M3 4v5h5" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
            Guardar cambios
        </button>
    </div>

    <div class="perm-role-bar">
        <div class="perm-filter-group">
            <label>Rol</label>
            <select [(ngModel)]="selectedRoleId" (ngModelChange)="onRoleChange()">
                <option [ngValue]="null">Selecciona un rol...</option>
                <option *ngFor="let rol of roles" [ngValue]="rol.id">{{rol.name}}</option>
            </select>
        </div>
        <div class="perm-filter-group perm-filter-group--search" *ngIf="selectedRoleId !== null">
            <label>Buscar módulo</label>
            <input type="text" placeholder="Buscar..." [(ngModel)]="searchTerm">
        </div>
    </div>

    <div class="perm-empty" *ngIf="selectedRoleId === null && !loadingRoles">
        <p>Selecciona un rol arriba para ver y editar sus permisos.</p>
    </div>

    <div class="perm-loading" *ngIf="loadingMatrix">
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Cargando...</span>
        </div>
        <p>Cargando permisos...</p>
    </div>

    <div class="perm-body" *ngIf="selectedRoleId !== null && !loadingMatrix">
        <div class="perm-main-col">
            <div class="perm-module-card" *ngFor="let modulo of modulosFiltrados">
                <div class="perm-module-card-header" (click)="toggleExpand(modulo)">
                    <div class="perm-module-icon" [class.perm-module-icon--group]="modulo.children.length > 0">
                        <svg *ngIf="modulo.children.length > 0" viewBox="0 0 24 24" width="18" height="18" fill="none"><path d="M3 7a2 2 0 012-2h4l2 2h8a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V7z" stroke="#00a0e1" stroke-width="1.8" stroke-linejoin="round"/></svg>
                        <svg *ngIf="modulo.children.length === 0" viewBox="0 0 24 24" width="18" height="18" fill="none"><circle cx="12" cy="8" r="3.2" stroke="#4b5563" stroke-width="1.8"/><path d="M5 20c1-3.5 4-5.5 7-5.5s6 2 7 5.5" stroke="#4b5563" stroke-width="1.8" stroke-linecap="round"/></svg>
                    </div>
                    <div class="perm-module-card-text">
                        <div class="perm-module-title-row">
                            <p class="perm-module-name">{{modulo.name}}</p>
                            <span class="perm-badge perm-badge--sub" *ngIf="modulo.children.length > 0">{{modulo.children.length}} submódulos</span>
                        </div>
                        <p class="perm-module-desc">{{modulo.children.length > 0 ? 'Grupo con menú desplegable — los permisos se asignan por cada submódulo.' : 'Módulo individual — sin submenú.'}}</p>
                    </div>
                    <span class="perm-badge" *ngIf="modulo.children.length === 0">{{countActivePermissions(modulo)}} permisos</span>
                    <button type="button" class="perm-chevron" [class.perm-chevron--open]="expandedModuleId === modulo.id">
                        <svg viewBox="0 0 24 24" width="16" height="16" fill="none"><path d="M6 9l6 6 6-6" stroke="#4b5563" stroke-width="2" stroke-linecap="round"/></svg>
                    </button>
                </div>

                <div class="perm-module-card-body" *ngIf="expandedModuleId === modulo.id">
                    <ng-container *ngIf="modulo.children.length > 0; else sinSubmenu">
                        <div class="perm-submodule-row perm-submodule-row--parent" *ngIf="modulo.actions.length > 0" [class.perm-submodule-row--inactive]="!modulo.is_active">
                            <div class="perm-row-top">
                                <span class="perm-submodule-name">{{modulo.name}} <em>(acceso directo al módulo)</em></span>
                                <label class="perm-access-switch">
                                    <input type="checkbox" [checked]="modulo.is_active" (change)="toggleChildAccess(modulo)">
                                    <span class="perm-access-track"></span>
                                    <span class="perm-access-label">Acceso</span>
                                </label>
                            </div>
                            <div class="perm-action-chips">
                                <label class="perm-chip" *ngFor="let accion of modulo.actions; let i = index" [class.perm-chip--active]="accion.is_active" [class.perm-chip--disabled]="!modulo.is_active" [class]="'perm-chip--c' + (i % 5)">
                                    <input type="checkbox" [checked]="accion.is_active" [disabled]="!modulo.is_active" (change)="toggleAction(modulo, accion)">
                                    <span class="perm-chip-dot"></span>
                                    {{accion.name}}
                                </label>
                            </div>
                        </div>
                        <div class="perm-submodule-row" *ngFor="let child of modulo.children" [class.perm-submodule-row--inactive]="!child.is_active">
                            <div class="perm-row-top">
                                <span class="perm-submodule-name">{{child.name}}</span>
                                <label class="perm-access-switch">
                                    <input type="checkbox" [checked]="child.is_active" (change)="toggleChildAccess(child)">
                                    <span class="perm-access-track"></span>
                                    <span class="perm-access-label">Acceso</span>
                                </label>
                            </div>
                            <div class="perm-action-chips">
                                <label class="perm-chip" *ngFor="let accion of child.actions; let i = index" [class.perm-chip--active]="accion.is_active" [class.perm-chip--disabled]="!child.is_active" [class]="'perm-chip--c' + (i % 5)">
                                    <input type="checkbox" [checked]="accion.is_active" [disabled]="!child.is_active" (change)="toggleAction(child, accion)">
                                    <span class="perm-chip-dot"></span>
                                    {{accion.name}}
                                </label>
                                <span class="perm-chip-empty" *ngIf="!child.actions.length">Sin acciones configuradas</span>
                            </div>
                        </div>
                    </ng-container>
                    <ng-template #sinSubmenu>
                        <div class="perm-submodule-row" [class.perm-submodule-row--inactive]="!modulo.is_active">
                            <div class="perm-row-top">
                                <span class="perm-submodule-name">{{modulo.name}}</span>
                                <label class="perm-access-switch">
                                    <input type="checkbox" [checked]="modulo.is_active" (change)="toggleChildAccess(modulo)">
                                    <span class="perm-access-track"></span>
                                    <span class="perm-access-label">Acceso</span>
                                </label>
                            </div>
                            <div class="perm-action-chips">
                                <label class="perm-chip" *ngFor="let accion of modulo.actions; let i = index" [class.perm-chip--active]="accion.is_active" [class.perm-chip--disabled]="!modulo.is_active" [class]="'perm-chip--c' + (i % 5)">
                                    <input type="checkbox" [checked]="accion.is_active" [disabled]="!modulo.is_active" (change)="toggleAction(modulo, accion)">
                                    <span class="perm-chip-dot"></span>
                                    {{accion.name}}
                                </label>
                                <span class="perm-chip-empty" *ngIf="!modulo.actions.length">Sin acciones configuradas</span>
                            </div>
                        </div>
                    </ng-template>
                </div>
            </div>

            <div class="perm-empty" *ngIf="!modulosFiltrados.length">
                <p>No hay módulos que coincidan con "{{searchTerm}}".</p>
            </div>
        </div>

        <div class="perm-side-col" *ngIf="expandedModule as modulo; else sideColHint">
            <div class="perm-side-card">
                <div class="perm-side-header">
                    <div class="perm-module-icon" [class.perm-module-icon--group]="modulo.children.length > 0">
                        <svg viewBox="0 0 24 24" width="18" height="18" fill="none"><path d="M12 3l7 3v6c0 4.5-3 8-7 9-4-1-7-4.5-7-9V6l7-3z" stroke="#00a0e1" stroke-width="1.8" stroke-linejoin="round"/></svg>
                    </div>
                    <p class="perm-side-title">{{modulo.name}}</p>
                </div>
                <p class="perm-side-desc" *ngIf="modulo.children.length > 0">
                    Módulo con submenú: agrupa {{modulo.children.length}} submódulos bajo un mismo grupo de permisos.
                </p>
                <p class="perm-side-desc" *ngIf="modulo.children.length === 0">
                    Módulo individual, sin submenú asociado.
                </p>
            </div>

            <div class="perm-side-card">
                <p class="perm-side-section-title">Acciones rápidas</p>

                <ng-container *ngIf="modulo.children.length > 0">
                    <button type="button" class="perm-quick-btn perm-quick-btn--primary" (click)="abrirEdicionGrupo(modulo)" *ngIf="bulkEditModuleId !== modulo.id">
                        Editar permisos del grupo
                    </button>

                    <div class="perm-bulk-edit" *ngIf="bulkEditModuleId === modulo.id">
                        <p class="perm-bulk-edit-title">Aplicar a todos los submódulos:</p>
                        <label class="perm-bulk-check" *ngFor="let nombre of accionesEstandarDe(modulo)">
                            <input type="checkbox" [(ngModel)]="bulkEditSelection[nombre]">
                            {{nombre}}
                        </label>
                        <div class="perm-bulk-edit-actions">
                            <button type="button" class="perm-quick-btn perm-quick-btn--primary" (click)="aplicarEdicionGrupo(modulo)">Aplicar</button>
                            <button type="button" class="perm-quick-btn" (click)="cancelarEdicionGrupo()">Cancelar</button>
                        </div>
                    </div>
                </ng-container>

                <button type="button" class="perm-quick-btn" *ngIf="modulo.children.length === 0">
                    Ver detalle del módulo
                </button>

                <button type="button" class="perm-quick-btn perm-quick-btn--danger" (click)="quitarAccesoAlGrupo(modulo)">
                    {{modulo.children.length > 0 ? 'Quitar acceso al grupo' : 'Quitar acceso al módulo'}}
                </button>
            </div>

            <div class="perm-side-card">
                <p class="perm-side-section-title">Resumen</p>
                <div class="perm-summary-row">
                    <span>Módulos con submenú</span>
                    <strong>{{resumen.modulosConSubmenu}}</strong>
                </div>
                <div class="perm-summary-row">
                    <span>Submódulos totales</span>
                    <strong>{{resumen.submodulosTotales}}</strong>
                </div>
                <div class="perm-summary-row">
                    <span>Con acceso</span>
                    <strong class="perm-summary-highlight">{{resumen.conAcceso}}</strong>
                </div>
            </div>

            <div class="perm-side-note" *ngIf="modulo.children.length > 0">
                Los cambios en un grupo con submenú se aplican a todos sus submódulos al guardar.
            </div>
        </div>

        <ng-template #sideColHint>
            <div class="perm-side-col">
                <div class="perm-side-card perm-side-card--hint">
                    <p>Selecciona un módulo de la izquierda para ver su detalle y acciones rápidas.</p>
                </div>
            </div>
        </ng-template>
    </div>
</div>
